/**
 * mSTEM mock Arduino codegen stub (DR-08).
 *
 * Returns a STATIC, symbolic Arduino sketch string for the Monaco code view
 * when "MBF Robot v1" is selected. This is NOT a real compiler/generator — it
 * does not read the workspace blocks. It is a representative educational stub
 * that maps to the 🤖 Robot palette (motor pins, servo, buzzer) so the student
 * sees plausible Arduino code. BE team will replace this with the real
 * Arduino code generator once hardware integration lands.
 *
 * MOCK-ONLY: no compilation, no upload, no side effects.
 */

const getRobotMockCode = () => [
    '// Mã Arduino mẫu (mô phỏng) — MBF Robot v1',
    '// (mô phỏng — không phải code biên dịch thật)',
    '',
    '#include <Arduino.h>   // board: Arduino UNO',
    '',
    '// Chân kết nối (mô phỏng) — motor l298n, còi passiveBuzzer',
    'const int MOTOR_LEFT  = 5;',
    'const int MOTOR_RIGHT = 6;',
    'const int BUZZER_PIN  = 9;',
    '',
    'void setup() {',
    '    pinMode(MOTOR_LEFT, OUTPUT);',
    '    pinMode(MOTOR_RIGHT, OUTPUT);',
    '    pinMode(BUZZER_PIN, OUTPUT);',
    '}',
    '',
    'void loop() {',
    '    // robot tiến — tốc độ 100',
    '    analogWrite(MOTOR_LEFT, 100);',
    '    analogWrite(MOTOR_RIGHT, 100);',
    '    delay(1000);',
    '',
    '    // phát âm thanh (mô phỏng)',
    '    digitalWrite(BUZZER_PIN, HIGH);',
    '    delay(500);',
    '    digitalWrite(BUZZER_PIN, LOW);',
    '',
    '    // dừng robot',
    '    analogWrite(MOTOR_LEFT, 0);',
    '    analogWrite(MOTOR_RIGHT, 0);',
    '    delay(1000);',
    '}',
    ''
].join('\n');

export {
    getRobotMockCode
};
